import parseDate from './parser'

export default parseDate
